import React from 'react';
import { Link } from 'react-router-dom';
import ChatIcon from '@mui/icons-material/Chat';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NavbarLogo from '../shared/NavbarLogo';
import NotificationDropdown from '../shared/NotificationDropdown';
import ProfileDropdown from '../shared/ProfileDropdown';
import UserAvatar from '../shared/UserAvatar';
import { Buyer } from '../../../../../Models/Buyer';
import { NotificationInterface } from '../../../../../Models/Notification';
import logoImageOrange from '../../../../../assets/images/branding/gg_navbar_brand_orange.png';
import logoImageGrey from '../../../../../assets/images/branding/gg_navbar_brand_grey.png';
import logoImageWhite from '../../../../../assets/images/branding/gg_navbar_brand_white.png';
import dashboardImg from '../../../../../assets/images/navbar/dashboard.svg';

interface SellerNavbarProps {
  scrolling: boolean;
  useWhiteText: boolean;
  buyer?: Buyer;
  unreadMsgCount?: number;
  unreadNotificationCount: number;
  navbarTopFiveNotifications: NotificationInterface[];
  showMenuPopup: string;
  onLogoClick: () => void;
  onMessagesClick: () => void;
  onDashboardClick: () => void;
  onMenuPopupHandler: (menu: string) => void;
  onNotificationClick: () => void;
  onMyProfileClick: () => void;
  onFavouritesClick: () => void;
  onOrdersClick: () => void;
  onContactUsClick: () => void;
  onSignOutClick: () => void;
}

const SellerNavbar: React.FC<SellerNavbarProps> = ({
  scrolling,
  useWhiteText,
  buyer,
  unreadMsgCount,
  unreadNotificationCount,
  navbarTopFiveNotifications,
  showMenuPopup,
  onLogoClick,
  onMessagesClick,
  onDashboardClick,
  onMenuPopupHandler,
  onNotificationClick,
  onMyProfileClick,
  onFavouritesClick,
  onOrdersClick,
  onContactUsClick,
  onSignOutClick
}) => {
  return (
    <div className={scrolling ? 'navbar scroll' : 'navbar'}>
      {/* Logo */}
      <NavbarLogo
        scrolling={scrolling}
        useWhiteText={useWhiteText}
        logoImageOrange={logoImageOrange}
        logoImageWhite={logoImageWhite}
        logoImageGrey={logoImageGrey}
        onLogoClick={onLogoClick}
      />

      {/* Navigation Links */}
      <div className="navbar-list">
        <Link className={useWhiteText ? 'navbar-list-links whiteText' : "navbar-list-links"} to="/categories">
          Categories
        </Link>
        <Link className={useWhiteText ? 'navbar-list-links whiteText' : "navbar-list-links"} to="/about">
          About Us
        </Link>
        <Link className={useWhiteText ? 'navbar-list-links whiteText' : "navbar-list-links"} to="/FAQs">
          FAQs
        </Link>
      </div>

      {/* Right Side Icons */}
      <div className="navbar-right-part-cover">
        {/* Messages Icon */}
        <div className="navbar-right-icon navbar-right-message" onClick={onMessagesClick}>
          <ChatIcon className={useWhiteText ? 'whiteText' : ''} />
          {unreadMsgCount !== 0 && <span className='navbar-right-icon-badge fav-badge'>{unreadMsgCount}</span>}
        </div>

        {/* Notifications Icon */}
        <div className="navbar-right-icon navbar-right-notify" onClick={() => onMenuPopupHandler('notification')}>
          <NotificationsIcon className={useWhiteText ? 'whiteText' : ''} />
          {unreadNotificationCount > 0 && (
            <span className='navbar-right-icon-badge fav-badge'>{unreadNotificationCount}</span>
          )}
        </div>

        {/* Dashboard Button */}
        <div className="navbar-right-icon navbar-right-dashboard" onClick={onDashboardClick}>
          <img src={dashboardImg} alt="dashboard" /> Dashboard
          <span className='navbar-right-icon-badge fav-badge' style={{ visibility: 'hidden' }}></span>
        </div>

        {/* User Avatar */}
        <UserAvatar buyer={buyer} onClick={() => onMenuPopupHandler('profile')} />

        {/* Notification Dropdown */}
        <div 
          onMouseLeave={() => onMenuPopupHandler('none')} 
          className={showMenuPopup !== 'notification' ? "navbar-icon-list-messagebox notification freelancer" : "navbar-icon-list-messagebox active notification freelancer"}
        >
          <NotificationDropdown
            notifications={navbarTopFiveNotifications}
            unreadCount={unreadNotificationCount}
            onNotificationClick={onNotificationClick}
          />
        </div>

        {/* Profile Dropdown */}
        <div 
          onMouseLeave={() => onMenuPopupHandler('none')} 
          className={showMenuPopup !== 'profile' ? "navbar-user-list-box" : "navbar-user-list-box active"}
        >
          <ProfileDropdown
            onMyProfileClick={onMyProfileClick}
            onFavouritesClick={onFavouritesClick}
            onOrdersClick={onOrdersClick}
            onContactUsClick={onContactUsClick}
            onSignOutClick={onSignOutClick}
          />
        </div>
      </div>
    </div>
  );
};

export default SellerNavbar;
